import { NEW_LIST_ELEMENTS } from "../routes/queries";
import {
  CREATE_NEW_ELEMENT,
  NEW_DELETE_ELEMENT,
  NEW_UPDATE_ELEMENT,
} from "../routes/mutations";
import { NewPageComponent } from "../components/page/NewPageComponent";
import { appendIdToFormFields, getEventMetadata, getSession } from "../helper";
import { Card, CardContent, CardHeader, Header } from "semantic-ui-react";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";
import { getSomedayMaybeFormFields } from "./someday_maybe_form";
import { SettingsCache } from "../cache/SettingsCache";
import { getNewNextActionFormFields } from "../nextaction/next_action_form";
import { getProjectFormFields } from "../projects/project_form";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import { LinkedReferenceLibraryElementsSection } from "src/referencelibrary/ReferenceLibraryElementSection";

const SomedayMaybeCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid key={props.data.id}>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <CardHeader style={{ fontSize: 18 }}>
            <b>{props.data.name}</b>
          </CardHeader>
          <CardDotMenuComponent
            cardData={props.data}
            props={{
              menuItems: [
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: NEW_DELETE_ELEMENT,
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    setReloadKey((k: number) => k + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                      isChildElement: true,
                    };
                  },
                  showMenuOption: (data: any) => {
                    return data.isChildElement;
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Delete",
                  apiCall: NEW_DELETE_ELEMENT,
                  modalHeader: "Choose Delete Strategy for " + props.data.name,
                  showMenuOption: (data: any) => {
                    return !data.isChildElement && !data.parentElement;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: [
                        {
                          type: "radio_button",
                          key: "parentDeletionStrategy",
                          label:
                            "When deleting this element, what should be done with its child elements?",
                          options: [
                            {
                              value: "delete_all",
                              label: "Delete all child elements",
                            },
                            {
                              value: "orphan_children",
                              label: "Keep all child elements",
                            },
                          ],
                        },
                      ],
                      type: "single_form",
                    },
                    startingData: {
                      id: props.data.id,
                      isChildElement: false,
                      parentDeletionStrategy: "delete_all",
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  label: "Delete",
                  apiCall: NEW_DELETE_ELEMENT,
                  modalHeader: "Choose Delete Strategy for " + props.data.name,
                  showMenuOption: (data: any) => {
                    return !data.isChildElement && data.parentElement;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: [
                        {
                          type: "radio_button",
                          key: "parentDeletionStrategy",
                          label:
                            "When deleting this element, what should be done with its child elements?",
                          options: [
                            {
                              value: "delete_all",
                              label: "Delete all child elements",
                            },
                            {
                              value: "orphan_children",
                              label: "Keep all child elements",
                            },
                            {
                              value: "promote_children",
                              label:
                                "Promote children to be under element's parent element",
                            },
                          ],
                        },
                      ],
                      type: "single_form",
                    },
                    startingData: {
                      id: props.data.id,
                      isChildElement: false,
                      parentDeletionStrategy: "delete_all",
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Edit",
                  modalHeader: "Edit Someday/Maybe Element " + props.data.name,
                  showMenuOption: () => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getSomedayMaybeFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                      lifeDomainId: props.data.lifeDomain
                        ? props.data.lifeDomain.id
                        : undefined,
                      parentElementId: props.data.parentElement
                        ? props.data.parentElement.id
                        : undefined,
                      id: props.data.id,
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Change to Next Action",
                  modalHeader: "Change Someday/Maybe Element to Next Action",
                  showMenuOption: (data: any) => {
                    console.log("showMenuOption data:", JSON.stringify(data));
                    return data.isChildElement;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getNewNextActionFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                      lifeDomainId: props.data.lifeDomain
                        ? props.data.lifeDomain.id
                        : undefined,
                      parentElementId: props.data.parentElement
                        ? props.data.parentElement.id
                        : undefined,
                      id: props.data.id,
                      priority:
                        SettingsCache.getInstance().getDefaultPriority(),
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: NEW_UPDATE_ELEMENT,
                  label: "Change to Project",
                  modalHeader: "Change Someday/Maybe Element to Project",
                  showMenuOption: (data: any) => {
                    console.log("showMenuOption data:", JSON.stringify(data));
                    return data.isChildElement;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: {
                      formFields: appendIdToFormFields(
                        getProjectFormFields(),
                        props.data,
                      ),
                      type: "single_form",
                    },
                    startingData: {
                      name: props.data.name,
                      lifeDomainId: props.data.lifeDomain
                        ? props.data.lifeDomain.id
                        : undefined,
                      parentElementId: props.data.parentElement
                        ? props.data.parentElement.id
                        : undefined,
                      id: props.data.id,
                      priority:
                        SettingsCache.getInstance().getDefaultPriority(),
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
              ],
            }}
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
          />
        </div>
      </Card.Content>
      {props.data.lifeDomain && (
        <CardContent className="life-domain-content">
          <div>
            <b>Life Domain: </b>
            {props.data.lifeDomain.name}
          </div>
        </CardContent>
      )}

      <CardContent className="children-elements">
        <Header>Children Elements</Header>
        {(props.data.children || []).map((child: any) => (
          <SomedayMaybeCard
            key={child.id}
            data={child}
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
          />
        ))}
      </CardContent>
      <Card.Content>
        <CardHeader>Next Actions</CardHeader>
        {props.data.childNextActions.map((child: any) => (
          <div>{child.name}</div>
        ))}
      </Card.Content>
      <Card.Content>
        <CardHeader>Projects</CardHeader>
        {props.data.childProjects.map((child: any) => (
          <div>{child.name}</div>
        ))}
      </Card.Content>
      <LinkedReferenceLibraryElementsSection
        data={props.data}
        setReloadKey={props.setReloadKey}
      />
    </Card>
  );
};

export const SomedayMaybePage = () => {
  return (
    <NewPageComponent
      props={{
        type: "parent_child_list",
        card: SomedayMaybeCard,
        parentItem: "parentElement",
        query: NEW_LIST_ELEMENTS,
        queryVariables: {
          session: getSession(),
          types: [3],
          appendTypeToName: false,
        },
        itemName: "Someday/Maybe Element",
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: {
              formFields: getSomedayMaybeFormFields(),
              type: "single_form",
            },
            startingData: {
              name: "",
              lifeDomainId: undefined,
              parentElementId: undefined,
            },
          }),
          apiCall: CREATE_NEW_ELEMENT,
        },
      }}
    />
  );
};
